import { render } from "./QuestionsDisplay.vue?vue&type=template&id=571e9bf8&ts=true"
import script from "./QuestionsDisplay.vue?vue&type=script&lang=ts"
export * from "./QuestionsDisplay.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__